import { paymentTypes } from "@/common/constant/PaymentTypes";

const initialPaymentMethod = {
  id: 0,
  name: "Pay at Store",
  type: paymentTypes.STORE,
  description: "",
  published: 1,
  ordering: 0,
  isDefault: 0,
  isDefaultDeposit: 0,
  isDefaultGateway: 0,
};

export { initialPaymentMethod };
